module.exports = __webpack_public_path__ + "img/acceptance.f3c42c09.png";